import { consoleInfo } from '@gravityforms/utils';
import animations from './animations';
import conditionalLogic from './conditional-logic';
import nav from './nav';
import welcome from './welcome';

/**
 * @function init
 * @description Kick off this modules functionality
 *
 */
const init = () => {
	animations();
	conditionalLogic();
	nav();
	welcome();

	consoleInfo( 'Gravity Forms Conversational Forms: Initialized form nav.' );
};

export default init;
